<template>
  <div class="w-100 pt-1">
    <div class="form-row">
        <div class="form-group form-inline w-100">
            <label for="surveyTakerId" class="mr-1">Survey Taker Id</label>
            <input type="text" class="form-control w-25" placeholder="Enter comma delimited list of survey taker ids" id="surveyTakerId" name="surveyTakerId" v-model="surveyTakerId" />
        </div>
    </div>
    <div class="mt-2 mb-2 row" role="group">
        <button type="submit" class="btn btn-primary float-right ml-2" @click="scoreSurvey()">
          <span>Score Survey</span>
          <span v-show="this.$root.getLoading()" class="spinner-border spinner-border-sm"></span>
        </button>
    </div>
    <div v-show="displayResults" class="dashboard-divider w-100"></div>
    <div class="data-container">
        <div class="col-11">
            <table v-show="displayResults" :id="table.id" :class="table.class" cellspacing="0" width="100%">
                <thead>
                    <tr>
                        <th>Survey Taker Id</th>
                        <th>Survey Taker Code</th>
                        <th>kS1</th>
                        <th>kS2</th>
                        <th>kS3</th>
                        <th>kS4</th>
                        <th>kS5</th>
                        <th>kS6</th>
                        <th>kS7</th>
                        <th>kS8</th>
                        <th>kS9</th>
                        <th>kS10</th>
                        <th>kS11</th>
                        <th>kS12</th>
                        <th>kS13</th>
                        <th>kS14</th>
                        <th>kS15</th>
                        <th>kS16</th>
                        <th>Quality Score</th>
                        <th>Grade</th>
                    </tr>
                </thead>
                <tbody></tbody>
            </table>
        </div>
        <div class="col-1"></div>
    </div>
    <div v-show="displayResults" class="dashboard-divider w-100"></div>
  </div>
</template>

<script>
import ViewMixins from "../mixins/ViewMixins.vue";
import DataTableMixins from "../mixins/DataTableMixins.vue";
import AdminService  from "../services/admin.service";
import SurveyScoreService  from "../services/survey.score.service";

export default {
  name: "SurveyQualityScore",
  mixins: [ViewMixins, DataTableMixins],
  components: {},
  data() {
    return {
        surveyTakerId: "",
        displayResults: false,
        surveyTakerList: [],
        surveyQualityScoreRecords: [],
        table: {
            id: "survey-quality-score-list-table",
            class: "table display wrap row-border table-hover",
            configuration: {
                dom: '<"top"if>rtp<"bottom"B><"clear">',
                searching: false,
                paging: true,
                select: true,
                pageLength: 10,
                destroy: true,
                info: false,
                ordering: true,
                bSort: true,
                bSortable: true,
                keys: true,
                autoWidth: false,
                processing: true,
                responsive: true,
            },            
            columns: SurveyScoreService.getTableColumnData(),
        },

    };
  },
  props: {
    inputSurveyCode: {
        type: String,
        default: ""
    },     
  },
  computed: {},
  mounted() {},
  created() {},
  methods: {
    scoreSurvey: function(){
        this.surveyTakerList = this.surveyTakerId.split(",");
        this.$root.processServerRequest("Calculating Survey Quality Score");
        SurveyScoreService.getSurveyQualityScore(this.surveyTakerList, this.inputSurveyCode, this.getSurveyQualityScoreCallback, this);
    },
    getSurveyQualityScoreCallback: function(response){
      this.$root.processServerResponse();
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        this.surveyQualityScoreRecords = response.data.data.surveyQualityScoreRecords;
        this.table.data = this.surveyQualityScoreRecords;
        this.setupTable();        
        let vm = this;
        setTimeout(() => {
            vm.displayResults = true;
        }, 500);        
        

        this.$notify(AdminService.displaySuccessMessage({ text: response.data.message, group: "auth" }));
      } else {
        this.$notify(AdminService.displayErrorMessage({ text: response.data.message }));
      }        
    }
  },
  watch: {},
};
</script>
